var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

export default invariant;



//////////////////
// WEBPACK FOOTER
// ../~/tiny-invariant/dist/tiny-invariant.esm.js
// module id = 682
// module chunks = 0